import { schemas } from 'modules/data';
import { api } from 'services/api';

export const getRequestDetailsMapped = (requestId: string, companyId: string) =>
    api.requests.getRequestDetails({ requestId, companyId }).then((data) => ({
        counterparty: data.counterparty,
        possibleDuplicates: (data.possibleDuplicates || []).map(schemas.request.mapPossibleDuplicateItem),
    }));
